import WorkdaySquareIcon from './WorkdaySquareIcon'

export default WorkdaySquareIcon
